import { useEffect, useState } from "react";
import { useIntl } from "react-intl";

type WarningFormProps = {
  isWarning: boolean;
  warningMessage: string | null;
  toggle: (isWarning: boolean) => void;
  change: (warningMessage: string) => void;
}

const WarningForm = ({isWarning, warningMessage, toggle, change}: WarningFormProps) => {
  const intl = useIntl();
  const [displayWarning, setDisplay] = useState(false);

  useEffect(() => {
    setDisplay(isWarning);
  }, [isWarning]);

  return (
    <div className="mb-5">
      <div className="mb-1.5 flex gap-2 items-center">
        <input id="isWarning" type="checkbox" name="isWarning"
          checked={isWarning || false} onChange={e => toggle(e.target.checked)}/>
        <label htmlFor="isWarning" className="block text-shadow text-sm">
          {intl.formatMessage({ id: 'forms.warning.label' })}
        </label>
      </div>
      {
        displayWarning ? (<>
        <textarea name="warningMessage" id="warning" rows={8}
          placeholder={intl.formatMessage({ id: 'forms.warning.placeholder' })}
          value={warningMessage || ''}
          onChange={e => change(e.target.value)}
          className="input"
        /></>) : <></>
      }
    </div>
  )
}

export default WarningForm;
